import { useEffect } from "react";
import { connect, useSelector } from "react-redux";
import { Navigate, Outlet, useOutlet } from "react-router-dom";
import mapStateToProps from "../services/mapStateToProps";

const AuthRoute = () => {
  const localOulet = useOutlet();
  const { isAuthUser, client_id, user_full_name } = useSelector(
    (state) => state.auth
  );

  useEffect(() => {
    console.group("AuthRoute");
    console.info(isAuthUser);
    console.info(client_id);
    console.info(user_full_name);
    console.groupEnd();
  }, [client_id, isAuthUser, localOulet, user_full_name]);

  if (!isAuthUser) {
    return <Navigate to={`${process.env.PUBLIC_URL}/login`} replace />;
  } else if (isAuthUser && localOulet === null) {
    return <Navigate to={`${process.env.PUBLIC_URL}/home`} replace />;
  }

  return (
    <main>
      <Outlet />
    </main>
  );
};

export default connect(mapStateToProps)(AuthRoute);
